
import {Button, DatePicker, message, Modal, Radio, Select, Spin} from "antd";
import React from "react";
import { CustomRow, CustomCol } from "../../components/Custom";

import { Row, Col, Form, InputNumber } from "antd";
import { mapAccountingRecordDataRange } from "../../axios/dictionaries";
import { postFrom } from "../../axios";
import {API_merchant_findAll, API_building_findBuildingList, API_Merchant_getCycleList} from "../../axios/config";
import { isDateRange } from "../../utils/validate";
import { formatTime } from "../../utils";
import moment from "moment";
import {
    fetchAccountingRecordAdd,
    fetchAccountingRecordGet,
    fetchAccountingRecordUpdate,
} from "../../services/accountingRecord";
/**
 * @Author: zhao - 🍉
 * @Date: 2021-12-17 16:33:28
 * @LastEditTime: 2021-12-22 11:54:43
 * @LastEditors: zhao - 🍉
 * @Description: 商户对账单 -编辑
 * @FilePath: /zhzj-admin/src/page/AccountingRecord/update.jsx
 */
class AccountingRecordUpdate extends React.Component {
    state = {
        id: null,
        visible: false,
        dataInfo: {},
        merchantList: [],
        buildingList: [],
        cycleList:[],
        dataLoading: false,
        submitLoading: false,
    };
    open(id = null) {
        if (id) {
            this.postAccountingRecordGet(id).then((res) => {
                this.postBuildingList(res.merchantId)
            });
        }
        this.postMerchantList();

        this.setState({ visible: true, id });
        return new Promise((resolve, reject) => {
            this.monitor = { resolve, reject };
        });
    }
    close() {
        this.setState({ visible: false ,cycleList:[]});
        this.props.form.resetFields();
    }
   

    postBuildingList(merchantId) {
        postFrom({ url: API_building_findBuildingList, data: { merchantId } })
            .then((res) => {
                this.setState({ buildingList: res });
            })
            .catch((err) => {
                message.error(err.message || "获取小区/楼栋列表失败");
            });
    }

    postMerchantList() {
        postFrom({
            url: API_merchant_findAll,
            data: {},
        })
            .then((res) => {
                let merchantList = res.map((item) => ({
                    title: item.shortName,
                    value: item.id,
                    name: item.name,
                    isJr: item.isJr,
                    zjbDataSync: item.zjbDataSync,
                }));
                this.setState({ merchantList });
            })
            .catch((err) => {
                message.error(err.message || "获取商户列表失败");
                this.setState({ loading: false });
            });
    }
    postSubmit(data) {
        const post = data.id ? fetchAccountingRecordUpdate : fetchAccountingRecordAdd;
        this.setState({ submitLoading: true });

        return post(data).finally((err) => {
            this.setState({ submitLoading: false });
        });
    }
    postAccountingRecordGet(id) {
        this.setState({ dataLoading: true });
        return fetchAccountingRecordGet({ accountingRecordLogId: id })
            .then((res) => {
                this.postScheduleCycle(res.merchantId)
                const value = this.parseRes(res)
                this.props.form.setFieldsValue(value);
                return value
            })
            .finally(() => {
                this.setState({ dataLoading: false });
            });
    }

    parseRes(res) {
        const result = {
            buildingIds: res.buildingIds || [],
            scheduleCycleId: res.scheduleCycleId,
            dataRange: 1,
            endDate: moment(res.endDate),
            merchantId: res.merchantId,
            paymentDate: moment(res.paymentDate),
            startDate: moment(res.startDate),
            advanceBillSettle:res.advanceBillSettle===1?true:false,
            historyAdvanceBillSettle:res.historyAdvanceBillSettle===1?true:false,
            balanceTransfer:res.balanceTransfer===1?true:false,
            _date: moment(res.year + "-" + res.month),
        };
        return result;
    }

    parseReq(data) {
        data.startDate = formatTime(data.startDate, "YYYY-MM-DD");
        data.endDate = formatTime(data.endDate, "YYYY-MM-DD");
        data.paymentDate = formatTime(data.paymentDate, "YYYY-MM-DD");
        data.buildingIds = data.buildingIds || [];
        data.year = formatTime(data._date, "YYYY");
        data.month = formatTime(data._date, "MM");
        data.dataRange=1;
        data.advanceBillSettle=data.advanceBillSettle?1:2;
        data.historyAdvanceBillSettle = data.historyAdvanceBillSettle?1:2;
        data.balanceTransfer = data.balanceTransfer?1:2;
        return { ...data, _date: undefined };
    }

    handleMerchantChange = (e) => {
        // 更新楼栋列表
        this.postScheduleCycle(e);
    };

    postScheduleCycle = (e) =>{
        this.setState({ cycleList: [] });
        this.props.form.setFieldsValue({collectionPeriod:null,_date:null});
        //获取商户的租金汇集计划
        postFrom({ url: API_Merchant_getCycleList, data: { merchantId:e } })
            .then((res) => {
                this.setState({ cycleList: res });
            })
            .catch((err) => {
                message.error(err.message || "获取小区/楼栋列表失败");
            });

    }

    handleDataRangeChange = () => {
        // 重置已选中的楼栋
        this.props.form.setFieldsValue({ buildingIds: [] });
    };

    handleSubmit() {
        this.props.form.validateFields((err, values) => {
            if (err) return;
            values.id = this.state.id || undefined;
            if (!isDateRange(values.startDate, values.endDate)) return message.warning("开始日期不能晚于结束日期");
            const data = this.parseReq(values);
            this.postSubmit(data)
                .then(() => {
                    this.close();
                    this.monitor.resolve();
                    message.success("保存成功");
                })
                .catch((e) => {
                    message.error(e.message);
                });
        });
    }

    renderFooter() {
        return (
            <div className="app-modal-footer">
                <Button type="primary" onClick={this.handleSubmit.bind(this)} loading={this.state.submitLoading}>
                    保存
                </Button>
                <Button onClick={this.close.bind(this)}>取消</Button>
            </div>
        );
    }

    render() {
        const modalConfig = {
            title: this.state.id ? "编辑" : "新增",
            visible: this.state.visible,
            footer: this.renderFooter(),
            width: 642,
            onCancel: () => this.close(),
        };
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const labelWidth = 100;
        const dataRange = getFieldValue("dataRange");
        return (
            <Modal {...modalConfig}>
                <Spin spinning={this.state.dataLoading}>
                    <div className="custom" style={{ padding: 20 }}>
                        <Form labelCol={{ span: 0 }} wrapperCol={{ span: 24 }}>
                            <Row>
                                <Col span={24}>
                                    <CustomRow>
                                        <CustomCol label="商户名称">
                                            {getFieldDecorator("merchantId", {
                                                rules: [{ required: true, message: "请选择" }],
                                            })(
                                                <Select
                                                    showSearch
                                                    // style={{ width: 275 }}
                                                    placeholder="请选择"
                                                    optionFilterProp={"children"}
                                                    onChange={this.handleMerchantChange}
                                                >
                                                    {this.state.merchantList.map((item, index) => (
                                                        <Select.Option value={item.value} key={item.value}>
                                                            {item.title}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            )}
                                        </CustomCol>

                                    </CustomRow>
                                    <CustomRow divider>
                                        <CustomCol labelStyle={{ width: labelWidth }} label="开始日期">
                                            {getFieldDecorator("startDate", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: "请选择开始日期",
                                                    },
                                                ],
                                            })(<DatePicker placeholder="开始日期" />)}
                                        </CustomCol>
                                        <CustomCol labelStyle={{ width: labelWidth }} label="结束日期">
                                            {getFieldDecorator("endDate", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: "请选择结束日期",
                                                    },
                                                ],
                                            })(<DatePicker placeholder="结束日期" />)}
                                        </CustomCol>
                                    </CustomRow>

                                    <CustomRow divider>
                                        <CustomCol labelStyle={{ width: labelWidth }} label="所属年月">
                                            {getFieldDecorator("_date", {
                                                rules: [{ required: true, message: "请选择所属年月" }],
                                            })(<DatePicker.MonthPicker placeholder="所属年月" month   onChange={(date) => {
                                                    if(date){
                                                        var flag=false;
                                                        var month=date.format('YYYY-MM');
                                                        var cycleList=  this.state.cycleList;
                                                        if(cycleList!=null){

                                                            for(var i=0;i<cycleList.length;i++){
                                                                console.log(moment(cycleList[i].collectionDate).format('YYYY-MM'));
                                                                if(moment(cycleList[i].collectionDate).format('YYYY-MM')===month){
                                                                    this.props.form.setFieldsValue({scheduleCycleId:cycleList[i].id});
                                                                    flag=true;
                                                                   //  this.setState({data:{collectionPeriod:cycleList[i].id}});
                                                                 }
                                                            }

                                                        }
                                                        if(!flag){
                                                            this.props.form.setFieldsValue({scheduleCycleId:null});
                                                        }
                                                    }else{
                                                        this.props.form.setFieldsValue({scheduleCycleId:null});
                                                    }
                                            }}/>)}
                                        </CustomCol>
                                        <CustomCol labelStyle={{ width: labelWidth }} label="汇集期数">
                                            {getFieldDecorator("scheduleCycleId", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: "请输入汇集期数",
                                                    },
                                                ],
                                            })(
                                                <Select
                                                    showSearch
                                                    // style={{ width: 275 }}
                                                    placeholder="请选择"
                                                    disabled={true}
                                                    optionFilterProp={"children"}
                                                >
                                                    {this.state.cycleList.map((item, index) => (
                                                        <Select.Option value={item.id} key={item.id}>
                                                            第{item.number}期
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            )}
                                        </CustomCol>
                                    </CustomRow>
                                    <CustomRow divider>
                                        <CustomCol labelStyle={{ width: labelWidth }} label="预交账单结清">
                                                {getFieldDecorator('advanceBillSettle', {
                                                    rules: [{ required: true, message: '请选择预交账单是否结清' }],
                                                })(
                                                    <Radio.Group >
                                                        <Radio value={false}>不结清</Radio>
                                                        <Radio value>结清</Radio>
                                                    </Radio.Group>
                                                )}
                                        </CustomCol>
                                        <CustomCol labelStyle={{ width: labelWidth }} label="历史预交结清">
                                            {getFieldDecorator('historyAdvanceBillSettle', {
                                                rules: [{ required: true, message: '请选择历史预交是否结清' }],
                                            })(
                                                <Radio.Group >
                                                    <Radio value={false}>不结清</Radio>
                                                    <Radio value>结清</Radio>
                                                </Radio.Group>
                                            )}
                                        </CustomCol>
                                    </CustomRow>

                                    <CustomRow divider>
                                        <CustomCol labelStyle={{ width: labelWidth }} label="商户结余划付">
                                            {getFieldDecorator('balanceTransfer', {
                                                rules: [{ required: true, message: '请选择是否生成商户结余金额退款划付' }],
                                            })(
                                                <Radio.Group >
                                                    <Radio value={false}>不生成</Radio>
                                                    <Radio value>生成</Radio>
                                                </Radio.Group>
                                            )}
                                        </CustomCol>
                                    </CustomRow>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default Form.create({ wrappedComponentRef: true })(AccountingRecordUpdate);



// WEBPACK FOOTER //
// ./src/page/AccountingRecord/update.jsx